import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useVerifyEmailMutation } from "../redux/slices/api/userApi";
import notify from "../components/common/notify";
import { handleError } from "../hooks/useApi";
import MetaTags from "../components/common/MetaTags";

// Functional component for verifying user email
const VerifyEmail = () => {
  // Retrieving search parameters from the URL
  const [searchParams] = useSearchParams();
  let token = searchParams.get("token");

  // React Router's navigate function
  const navigate = useNavigate();

  // Mutation for verifying the email token
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();

  // Function to handle the verification of the email
  const handleVerifyEmail = async () => {
    try {
      // Invoking the verifyEmail mutation
      const res = await verifyEmail({ body: { token } }).unwrap();

      // Displaying a success notification
      notify(res?.message, "success");

      // Navigating to the profile page so they can see their verified status
      navigate("/profile");
    } catch (error) {
      // Handling and displaying an error notification
      handleError(error, null, true);
    }
  };

  // Ref to track whether the component has already executed
  const isRan = useRef(false);

  // Effect to trigger email verification when the component mounts
  useEffect(() => {
    if (isRan.current) return;
    if (token) {
      // Invoking the handleVerifyEmail function
      handleVerifyEmail();
      isRan.current = true;
    }
  }, [token]);

  // JSX structure for the component
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center text-center">
      <MetaTags
        title="Verify Email"
        description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
        link="/verify-email"
        noIndex
      />

      <p className="text-xl">
        Your email is being checked for confirmation, Please wait a moment ...
        <br />
        if nothing happens, click the button below.
      </p>
      <button
        // onClick={handleVerifyEmail}
        disabled={isLoading}
        className={`w-48 h-10 mt-10 bg-light-primary flex justify-center items-center text-white text-sm  rounded-lg disabled:cursor-not-allowed disabled:opacity-70 ${
          isLoading ? "animate-pulse red-gradient" : "bg-light-primary"
        }`}
      >
        {isLoading ? "Verifying email ..." : "Verify Email"}
      </button>
    </div>
  );
};

export default VerifyEmail;
